export default ({ app }) => {
  app.router.afterEach((to, from) => {
    if (to.name === 'game-offical-game_id-play') {
      const gameid = to.params.game_id
      const serverid = to.query.server_id || 0
      const isHasServerId = Number(serverid) !== 0
      isHasServerId && app.$util.loginStat(`YXY`, `游戏页`)
      isHasServerId && app.$util.gameInitStat(gameid)
      return
    } else if (to.name === 'gifts-gift_id') {
      app.$util.loginStat(
        `LBZX/LBXQ/${to.params.gift_id}`,
        `礼包中心/礼包详情/${to.query.title}`
      )
      return
    } else if (to.name === 'game-offical-game_id-server-list-update') {
      app.$util.loginStat(
        `${to.params.game_id}/GW/GDFWQ`,
        `${to.params.game_id}/官网/更多服务器`
      )
      return
    }
    const actions = new Map([
      [
        /^(?:\/(?=$))?$/i,
        {
          eid: 'GWSY',
          eid_desc: '官网首页'
        }
      ],
      [
        /^\/all-game/i,
        {
          eid: 'QBYX',
          eid_desc: '全部游戏'
        }
      ],
      [
        /^\/recharge/i,
        {
          eid: 'ZHCZ',
          eid_desc: '账号充值'
        }
      ],
      [
        /^\/gifts/i,
        {
          eid: 'LBZX',
          eid_desc: '礼包中心'
        }
      ],
      [
        /^\/personal/i,
        {
          eid: 'GRZX',
          eid_desc: '个人中心'
        }
      ],
      [
        /^\/customer/i,
        {
          eid: 'KFZX',
          eid_desc: '客服中心'
        }
      ],
      [
        /^\/vip-rights/i,
        {
          eid: 'GZTQ',
          eid_desc: '贵族特权'
        }
      ],
      [
        /^\/game-offical/i,
        {
          eid: `${to.params.game_id}/GW/SY`,
          eid_desc: `${to.params.game_id}/官网/首页`
        }
      ]
    ])
    const action = [...actions].filter(
      ([key, value]) =>
        key.test(to.path) && (!key.test(from.path) || to.path === from.path)
    )
    action.forEach(([key, value]) => {
      app.$util.loginStat(value.eid, value.eid_desc)
    })
  })
}
